<template>
    <div class="announ">
        <div class="warp-block">
           <div class="width-block common-space-between">
             <div class="block common-items-center EQumentBlock">
                   <div class="content">
                      <div class="common-space-around">
                         <animate-number class="number" ref="reNum" from="0" :to="deviceCount" :key="deviceCount" duration="2000"></animate-number>
                      </div>
                      <div class="common-textCenter text">接入设备总数</div>
                   </div>
               </div>
               <div class="block common-items-center IOTbLOCK">
                   <div class="content">
                      <div class="common-space-around">
                         <animate-number class="number" ref="reNum" from="0" :to="deviceTypeCount" :key="deviceTypeCount" duration="2000"></animate-number>
                      </div>
                      <div class="common-textCenter text">接入设备总类</div>
                   </div>
               </div>
               <div class="block common-items-center  projectBlock">
                   <div class="content">
                      <div class="common-space-around">
                         <animate-number class="number" ref="reNum" from="0" :to="projectCount" :key="projectCount" duration="2000"></animate-number>
                      </div>
                      <div class="common-textCenter text">承接项目总数</div>
                   </div>
               </div>
               <div class="block common-items-center factoBlock">
                   <div class="content">
                      <div class="common-space-around ">
                         <animate-number class="number" ref="reNum" from="0" :to="factoryCount" :key="factoryCount"  duration="2000"></animate-number>
                      </div>
                      <div class="common-textCenter text">工厂总数</div>
                   </div>
               </div>

           </div>
        </div>
    </div>
</template>
<script>
import {url,operate} from '@/utils/config'
import {postFun,deleteFun} from '@/utils/httpFun'
export default {
    components:{
       
    },
    props:{
      width:{
        type:Number,
        default:100
      }  
    },
    data(){
        return {
            deviceCount:0,
            deviceTypeCount:0, 
            factoryCount:0,
            projectCount:0,
        }
    },
   
    mounted() {
        this.getNumber()
    },
    methods:{
        getNumber(){
            postFun(operate.PROJECTUSER,{},res=>{
               this.deviceCount=res.data.deviceCount
               this.deviceTypeCount=res.data.deviceTypeCount
               this.factoryCount=res.data.factoryCount
               this.projectCount=res.data.projectCount 
            })
        }
    },
}
</script>
<style lang="scss" scoped>
    .announ{
        background: #FFFFFF;
        border-radius: 0 10px 10px 10px;
        width:100%;
        padding:20px;
        box-sizing: border-box; 
    }
    .title{
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #323F51;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .warp-block{
        width:100%;
       .width-block{
         width:100%;
         display: flex;
         flex-wrap: wrap;
       }
       .block{
            width:24%;
            height: 154px;
            border-radius: 12px;
            cursor: pointer;
        }
        .number{
            font-family: DINAlternate-Bold;
            font-size: 42px;
            font-weight: 700;
            color: #FFFFFF;
        }
        .text{
            font-size: 18px;
            font-weight: 400;
            padding-top:8px;
            color: #FFFFFF;
        }
        .content{
            width: 100%;
        }
    }
    .projectBlock{
        background-image: linear-gradient(180deg, #FFD13D 0%, #FF8048 100%);
    }
    .factoBlock{
        background-image: linear-gradient(0deg, #0F8DFF 0%, #54D1FF 100%);
    }
    .EQumentBlock{
        background-image: linear-gradient(0deg, #08B760 0%, #47E696 100%);
    }
    .IOTbLOCK{
        background-image: linear-gradient(0deg, #CC6FFE 0%, #DCAFFE 100%); 
    }
</style>
